import type { NavigationScope, NavigationScopeName, NavigationScopeOptions } from "./scope.types";

/**
 *
 */
export type AnyNavigationScope = NavigationScope<NavigationScopeName, NavigationScopeOptions>;

/**
 *
 *
 *
 */
export const scopeCache = new Map<string, AnyNavigationScope>();

/**
 *
 */
export const scopesFiltered = new Map<string, Set<AnyNavigationScope>>();

/**
 *
 */
export const hashFiltered = new Map<string, Set<AnyNavigationScope>>();

/**
 *
 */
export const searchFiltered = new Map<string, Set<AnyNavigationScope>>();

/**
 *
 */
export const pathFiltered = new Map<RegExp, Set<AnyNavigationScope>>();
